// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__xvcPw","logo":"footer_logo__0KLOb","footer_icon":"footer_footer_icon__ohusy"};